import { CardHeader, Tooltip } from "@material-tailwind/react";
import React from "react";
import { SeedItemProps } from "./SeedItem";
import styles from "./SeedItem.module.css";
import { getInitials } from "../../utils/common";
import Avatar from "../../design-system/Avatar";
import { FaBook } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

function BookPodcastItemInSeedSearch({ seed, onCitationClick }: Readonly<SeedItemProps>  & {onCitationClick:any}) {
    const navigate = useNavigate();
    const bookCitationClicked = () => {
        // const podcastCitation = seed?.citation?.replace(/\.txt$/, "");
        navigate(`/book/${seed.book_name}/${seed.chapter}`);
    };
    function onCitationClicked(seed: any): void {
        if (onCitationClick) {
          onCitationClick(seed);
        }
      }
    return (
        <div  onClick={e => {
            e.preventDefault();
            onCitationClicked(seed);
        }} className="my-2 cursor-pointer hover:cursor-pointer ">
            <CardHeader className="relative">
                <div className={`${styles.book_header} p-1 text-gray-700`}>
                    <div className="flex items-center">
                        <Tooltip content={seed.book_name} className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="right">
                            <div>
                                <Avatar initials={getInitials(seed.book_name)} className="mr-2" />
                            </div>
                        </Tooltip>
                    </div>
                    <span className={`justify-self-center truncate w-full max-w-full text-gray-500`}>{}</span>
                    <h2 className={`justify-self-center font-title truncate w-full max-w-full`} title={seed.book_name}>
                        {seed.book_name} - {seed.chapter}
                    </h2>
                    <div className="flex gap-4">
                        <Tooltip content="Book" className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="top">
                            <div>
                                <FaBook className="inline" />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </CardHeader>
        </div>
    );
}

export default BookPodcastItemInSeedSearch;
